/**
 * Algolia Quick Search Dialog
 * Handles the header search popup dialog functionality
 */
document.addEventListener('DOMContentLoaded', function () {

});


document.addEventListener('algolia.autocomplete.afterInit', function () {
	algoliaShopify.config.show_products = true;

  const shopifyAppEmbeds = document.querySelectorAll('body > .shopify-app-block');
	const algoliaEmbed = [...shopifyAppEmbeds].find(embed => embed.querySelector('.algolia-config-money-format'));

    if (algoliaEmbed) {
        const algoliaEmbedStyles = algoliaEmbed.querySelectorAll('style');
        algoliaEmbedStyles.forEach(style => {
            style.remove();
        });
    }
});

/**
 * Handles click on a search suggestion in the Quick Search popup.
 * Prevents default navigation, updates the search input, and triggers a new search.
 * @param {string} query - The search query from the clicked suggestion.
 */
function handleSuggestionClick(query, isMobile) {
  // Target both desktop and mobile Algolia search inputs
  // const input = isMobile ? document.querySelector('.aa-DetachedFormContainer .aa-Input') : document.querySelector('.aa-Input');
  const input = document.querySelector('.aa-Input');
  
  if (!input) {
    console.error('Algolia Quick Search input field not found.');
    return;
  }

  input.value = query;
  // Programmatically trigger an 'input' event to force Algolia Autocomplete to update
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

/**
 * Attaches a capturing event listener to the suggestion list to override
 * default Algolia click behavior. This is more performant and reliable
 * than using MutationObservers to clone nodes.
 * @param {HTMLElement} container - The parent container of the autocomplete panel.
 * @param {boolean} isMobile - Flag to determine which search input to target.
 */
function attachSuggestionClickHandler(container, isMobile) {
    const suggestionList = container.querySelector('[id*="querySuggestionsPlugin-list"]');
    
    // Ensure the listener is attached only once.
    if (suggestionList && !suggestionList.dataset.clickListenerAttached) {
        suggestionList.dataset.clickListenerAttached = 'true';
        
        suggestionList.addEventListener('click', (e) => {
            // By using the capture phase (true), this listener fires before Algolia's.
            // We stop the event from continuing, preventing the default navigation.
            e.preventDefault();
            e.stopPropagation();

            const querySource = e.target.closest('[data-query]');
            if (querySource) {
                handleSuggestionClick(querySource.dataset.query, isMobile);
            }
        }, true); // <-- The 'true' flag enables the capture phase.
    }
}

document.addEventListener('algolia.hooks.initialize', function () {

  const unsupportedCountries = [
		'AU',
		'BH',
		'CZ',
		'DK',
		'IN',
		'KW',
		'LI',
		'NO',
		'OM',
		'PL',
		'QA',
		'SA',
		'SE',
		'CH',
		'AE',
		'GB',
		'US'
	];

	
	
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {

		// console.log('beforeAutocompleteFiltersString defaultFilter', _defaultFilter);

		let additionalFilter = '';
		
		if(_defaultFilter) {
			additionalFilter = ' AND NOT tags:ghost_product'
		}
		else {
			additionalFilter = 'NOT tags:ghost_product'
		}

		if(
			(Shopify.locale == "fr" && unsupportedCountries.includes(Shopify.country))
			|| (Shopify.country == "CA" && Shopify.locale == "en")
		) {
			additionalFilter = additionalFilter + ' AND NOT tags:do_not_sell_in_canada'		
		}

		return _defaultFilter + additionalFilter;
	});


	algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
		const MIN_QUERY_LENGTH = 3;
		
		console.log('⚙️ beforeAutocompleteOptions - Incoming:', {
			options: options,
			hasSources: !!options.getSources,
			hasPlugins: !!options.plugins,
			keys: Object.keys(options)
		});
		
		options = {
			// On mobile, let Algolia handle its own detached experience
			detachedMediaQuery: '(max-width: 767px)',
			...options,
			placeholder: window.algoliaLocales.search_input_placeholder,
			panelContainer: document.querySelector('#qs-autocomplete-results'),
		}

		console.log('⚙️ beforeAutocompleteOptions - Outgoing:', options);

		return options;
	});


	// ========================================
	// MIN LENGTH + DEBOUNCE: Prevent excessive API calls
	// ========================================
	const MIN_QUERY_LENGTH = 3;
	const DEBOUNCE_MS = 500;
	
	let lastQuery = '';
	let lastInputTime = 0;
	let queryCount = 0;
	let debounceTimer = null;
	let shouldAllowSearch = true; // Start as true

	// Update search warning message
	// function updateSearchWarning(query) {
	// 	const shouldShowWarning = query.length > 0 && query.trim().length < MIN_QUERY_LENGTH;
		
	// 	// === DESKTOP ===
	// 	const desktopWarning = document.getElementById('qs-min-length-warning');
	// 	const desktopResults = document.getElementById('qs-autocomplete-results');
		
	// 	if (desktopWarning) {
	// 		if (shouldShowWarning) {
	// 			desktopWarning.style.display = 'flex';
	// 			if (desktopResults) desktopResults.style.display = 'none';
	// 		} else {
	// 			desktopWarning.style.display = 'none';
	// 			if (desktopResults) desktopResults.style.display = 'block';
	// 		}
	// 	}
		
	// 	// === MOBILE (Detached Modal) ===
	// 	const mobileOverlay = document.querySelector('.aa-DetachedOverlay');
	// 	if (mobileOverlay) {
	// 		const formContainer = mobileOverlay.querySelector('.aa-DetachedFormContainer');
	// 		const mobilePanel = mobileOverlay.querySelector('.aa-Panel');
			
	// 		if (formContainer) {
	// 			// Check if warning already exists AFTER form container (as sibling)
	// 			let mobileWarning = formContainer.nextElementSibling;
	// 			if (!mobileWarning || !mobileWarning.classList.contains('qs-min-length-warning')) {
	// 				mobileWarning = null;
	// 			}
				
	// 			// If not, clone from desktop and insert AFTER form container
	// 			if (!mobileWarning && desktopWarning) {
	// 				mobileWarning = desktopWarning.cloneNode(true);
	// 				mobileWarning.id = 'qs-min-length-warning-mobile'; // Different ID for mobile
	// 				// Insert AFTER formContainer (as sibling)
	// 				formContainer.insertAdjacentElement('afterend', mobileWarning);
	// 			}
				
	// 			// Show/hide warning and results on mobile
	// 			if (mobileWarning) {
	// 				if (shouldShowWarning) {
	// 					mobileWarning.style.display = 'flex';
	// 					if (mobilePanel) mobilePanel.style.display = 'none';
	// 				} else {
	// 					mobileWarning.style.display = 'none';
	// 					if (mobilePanel) mobilePanel.style.display = 'block';
	// 				}
	// 			}
	// 		}
	// 	}
	// }

	// Force autocomplete to re-evaluate by triggering input event
	function triggerAutocompleteRefresh() {
		const input = document.querySelector('.aa-Input');
		if (input) {
			// Trigger a custom event that Algolia listens to
			const event = new Event('input', { bubbles: true });
			input.dispatchEvent(event);
			console.log('🔄 Triggered autocomplete refresh');
		}
	}

	// This hook runs on EVERY KEYSTROKE before any search query is executed
	algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', function(config, context) {
		const query = config.queries[0]?.query || '';
		const now = Date.now();
		queryCount++;

		// Update warning
		// updateSearchWarning(query);

		// If query changed, start debounce
		if (query !== lastQuery) {
			lastQuery = query;
			lastInputTime = now;
			
			// Clear previous timer
			if (debounceTimer) {
				clearTimeout(debounceTimer);
			}

			const queryLength = query.trim().length;
			
			// If query is too short, block immediately
			if (queryLength < MIN_QUERY_LENGTH) {
				shouldAllowSearch = false;
				console.log(`📝 Query "${query}" too short - BLOCKING`);
			} else {
				// Query is valid length, start debounce
				shouldAllowSearch = false;
				console.log(`📝 Query "${query}" changed - starting ${DEBOUNCE_MS}ms debounce`);
				
				debounceTimer = setTimeout(function() {
					shouldAllowSearch = true;
					console.log(`✅ Debounce complete - triggering search for "${query}"`);
					triggerAutocompleteRefresh();
				}, DEBOUNCE_MS);
			}
		}

		console.log(`🔄 [${queryCount}] ${context.sourceId}: "${query}" (${query.trim().length} chars) - ${shouldAllowSearch ? 'ALLOW' : 'BLOCK'}`);

		// Return proper config if allowed, empty object if blocked
		if (shouldAllowSearch) {
			return config;
		} else {
			return {};
		}
	});
  

	// Product template hook - reusing search page product card
	algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
		const { html, item: hit, components } = templateOptions;

    // console.log('QUICK SEARCH HIT', hit);
		// All the HTML generation is now in the helper
		return window.algoliaProductHelpers.createProductCardHTML(hit, {
			html,
			components,
			itemLink,
			trackSearchAttribution,
		}, 'autocomplete');
	});

    
  // Custom hook for two-column autocomplete layout
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html, state } = templateOptions;

      // console.log('ELEMENTS', elements);
      
      // Return custom two-column layout with cleaner class names
      return html`
          <div class="qs-panel-left">
              ${displaySuggestions && html`
                  <div class="qs-source">
                      <span class="qs-section-header">
                          ${algoliaShopify.translations.suggestions}
                      </span>
                      ${elements.querySuggestionsPlugin}
                  </div>
              `}

                <div class="qs-source">
                    <span class="qs-section-header">
                        ${algoliaShopify.translations.collections}
                    </span>
                    ${elements.collections}
                </div>
                <!-- ${elements.redirectUrlPlugin} -->
            </div>

          <div class="qs-panel-right">
              ${elements.products}

              <div class="qs-footer">
                <a
                  class="qs-see-all-btn"
                  href="${window.Shopify.routes.root}search?q=${state.query}"
                >
                  ${algoliaShopify.translations.allProducts} (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
                </a>
              </div>
          </div>
      `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html } = templateOptions;
    return html`

    `;
  });

  
  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`

    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="qs-no-results">
        <div class="qs-no-results__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="11"></line><line x1="11" y1="14" x2="11.01" y2="14"></line></svg>
        </div>
        <p class="qs-no-results__message">
          ${window.algoliaLocales.no_results.replace('[query]', `"${state.query}"`)}
        </p>
      </div>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;

      // console.log('COLLECTIONS ITEM QUICK SEARCH', item);

        if (item.products_count < 1) {
          return html``;
        }
        return  html`
            <a href="${itemLink}" class="qs-item-link">
                ${components.Highlight({ hit: item, attribute: 'title' })}
            </a>
        `;
    });
    
    algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
        const { html, item, components } = templateOptions;

      // console.log('SUGGESTIONS TEMPLATE', templateOptions);
      
      return html`
          <span
            class="qs-item-link suggestion-button"
            data-query="${item.query}"
          >
              ${components.Highlight({ hit: item, attribute: 'query' })}
          </span>
      `;
  });      


  console.log('Algolia Quick Search initialized');

  /**
   * Desktop inline results (no <dialog>): mirror open/close side effects from AlgoliaSearchDialog
   * when #qs-autocomplete-results gains or loses .aa-Item nodes.
   */
  let desktopQuickSearchOverlayOpen = false;
  const quickSearchAnnouncementSection =
    document.querySelector('.shopify-section.announcement-bar-section') ||
    document.querySelector('.utility-bar-section');

  function openDesktopQuickSearchOverlay() {
    if (desktopQuickSearchOverlayOpen || window.innerWidth < 768) return;

    const announcementHeight = quickSearchAnnouncementSection?.offsetHeight || 0;
    const scrollTop = document.scrollingElement?.scrollTop || 0;
    if (scrollTop < announcementHeight) {
      window.scrollTo({
        top: announcementHeight,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      document.body.classList.add('overflow-hidden', 'SearchModalActive');
      desktopQuickSearchOverlayOpen = true;
    }, 500);
  }

  function closeDesktopQuickSearchOverlay() {
    if (!desktopQuickSearchOverlayOpen) return;

    document.body.classList.remove('overflow-hidden', 'SearchModalActive');
    desktopQuickSearchOverlayOpen = false;
  }

  // function ensureDesktopQuickSearchDismissListeners() {
  //   if (ensureDesktopQuickSearchDismissListeners.done) return;
  //   ensureDesktopQuickSearchDismissListeners.done = true;

  //   document.addEventListener('keydown', (e) => {
  //     if (e.key !== 'Escape') return;
  //     if (!desktopQuickSearchOverlayOpen || window.innerWidth < 768) return;
  //     e.preventDefault();
  //     closeDesktopQuickSearchOverlay();
  //     const input = document.querySelector(
  //       '#qs-autocomplete-form input[type="search"], #qs-autocomplete-form .aa-Input'
  //     );
  //     input?.blur();
  //   });
  // }
  
  // --- Helper function for dynamic mobile layout ---
  function applyMobileScrollLayout(panelSelector) {
    if (window.innerWidth >= 768) return; // Only run on mobile

    const sources = document.querySelectorAll(`${panelSelector} .qs-source`);
    sources.forEach(source => {
      const list = source.querySelector('.aa-List');
      if (!list || !list.firstElementChild) return;

      // Reset first to measure natural height
      if (source.classList.contains('is-horizontally-scrollable')) {
        source.classList.remove('is-horizontally-scrollable');
      }

      const firstItem = list.firstElementChild;
    //   const itemStyles = window.getComputedStyle(firstItem);
      const itemHeight = firstItem.offsetHeight + 5;
      const twoLinesHeight = itemHeight * 2;

      if (list.scrollHeight > twoLinesHeight) {
        source.classList.add('is-horizontally-scrollable');
      }
    });
  }

  /**
   * Creates a MutationObserver for a given panel (desktop or mobile) to handle
   * dynamic content changes, such as fetching extra data and attaching event listeners.
   * This is a reusable function to avoid code duplication.
   * @param {HTMLElement} panelElement - The autocomplete panel to observe.
   * @param {boolean} isMobile - A flag to indicate if it's the mobile view.
   */
  function setupPanelObserver(panelElement, isMobile) {
    // ensureDesktopQuickSearchDismissListeners();

    const observer = new MutationObserver(async (mutations, obs) => {
        const hasContent = panelElement.querySelector('.aa-Item');

        if (!isMobile) {
          if (hasContent) {
            openDesktopQuickSearchOverlay();
          } else {
            closeDesktopQuickSearchOverlay();
          }
        }

        if (!hasContent) {
          return;
        }

        obs.disconnect();

        const panelSelector = isMobile ? '.aa-DetachedOverlay' : '#qs-autocomplete-results';

        if (window.algoliaProductHelpers && panelElement.querySelector('.ais-product')) {
            // await window.algoliaProductHelpers.fetchAdditionalProductData(panelSelector);
        }

        attachSuggestionClickHandler(panelElement, isMobile);

        if (isMobile) {
            applyMobileScrollLayout(panelSelector);
        }

        obs.observe(panelElement, { childList: true, subtree: true });
    });

    observer.observe(panelElement, { childList: true, subtree: true });
  }

  // --- Setup observer for the main desktop panel ---
  const resultsWrapper = document.getElementById('qs-autocomplete-results');
  if (resultsWrapper) {
      setupPanelObserver(resultsWrapper, false);
  }

  const scrollLockElems = document.querySelectorAll('body, html, #MainContent');

  // --- Setup a MutationObserver to detect when the mobile panel is added/removed ---
  const bodyObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check for ADDED nodes (overlay opened)
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.matches('.aa-DetachedOverlay')) {
            // Mobile panel opened - lock scroll on both html and body (iOS fix)
            scrollLockElems.forEach(element => {
              element.classList.add('algolia-mobile-overlay-active');
              element.dataset.lastScrollTop = element.scrollTop;

              setTimeout(() => {
                element.scrollTop = 0;
              }, 100);
            });
            console.log('🔒 Mobile overlay opened - scroll locked');
            
            // Set up the panel observer
            setupPanelObserver(node, true);
          }
        }
        
        // Check for REMOVED nodes (overlay closed)
        for (const node of mutation.removedNodes) {
          if (node.nodeType === 1 && node.matches('.aa-DetachedOverlay')) {
            // Mobile panel closed - unlock scroll
            scrollLockElems.forEach(element => {
              element.classList.remove('algolia-mobile-overlay-active');

              setTimeout(() => {
                element.scrollTop = element.dataset.lastScrollTop;
                delete element.dataset.lastScrollTop;
              }, 100);
            });
            
            console.log('🔓 Mobile overlay closed - scroll unlocked');
          }
        }
      }
    }
  });

  // Keep observing the body to detect both add and remove events
  bodyObserver.observe(document.body, { childList: true });
});




// class AlgoliaSearchDialog extends HTMLElement {
//   constructor() {
//     super();
    
//     this.isOpen = false;
//     this.dialog = this.querySelector('.algolia-dialog');
//     this.closeButton = this.querySelector('.algolia-dialog__close');
//     this.popupId = this.dataset.popupId;
//     this.activeTrigger = null;
//     this.isInitialized = false;
//     this.announcementSection = document.querySelector('.shopify-section.announcement-bar-section');
    
//     this.init();
//   }

//   init() {
//     if (this.isInitialized) return; // Prevent multiple initializations
    
//     // Handle close button click
//     if (this.closeButton) {
//       this.closeButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         this.closeModal();
//       });
//     }

//     // Handle backdrop click
//     if (this.dialog) {
//       this.dialog.addEventListener('click', (e) => {
//         if (e.target === e.currentTarget) {
//           e.preventDefault();
//           e.stopPropagation();
//           this.closeModal();
//         }
//       });
//     }

//     // Handle escape key
//     this.escapeHandler = (e) => {
//       if (e.key === 'Escape' && this.isOpen) {
//         e.preventDefault();
//         this.closeModal();
//       }
//     };
//     document.addEventListener('keydown', this.escapeHandler);

//     // Use event delegation for trigger clicks
//     this.setupEventDelegation();
    
//     this.isInitialized = true;
//   }

//   setupEventDelegation() {
//     // Single document click listener for all trigger buttons
//     this.triggerClickHandler = (e) => {
//       const trigger = e.target.closest(`[data-search-popup="${this.popupId}"]`);
      
//       if (trigger) {
//         e.preventDefault();
//         e.stopPropagation();

//         // On mobile, instead of opening our dialog, we find the hidden Algolia button and click it
//         if (window.innerWidth < 768) {
//           // This is the button Algolia's script uses to open the detached search
//           const algoliaMobileTrigger = document.querySelector('.aa-DetachedSearchButton');
//           if (algoliaMobileTrigger) {
//             algoliaMobileTrigger.click();
//           }
//           return; // Stop further execution for mobile
//         }
        
//         if (this.isOpen && this.activeTrigger === trigger) {
//           // If clicking the same trigger that opened the dialog, close it
//           this.closeModal();
//         } else {
//           // Open dialog and track which trigger opened it
//           this.activeTrigger = trigger;
//           this.openModal();
//         }
//         return;
//       }
      
//       // Check if click is outside the dialog to close it
//       if (this.isOpen) {
//         const dialogContent = this.dialog.querySelector('.algolia-dialog__content');
//         const isInsideDialog = dialogContent && dialogContent.contains(e.target);
//         const isInsideAlgoliaDropdown = e.target.closest('.aa-Panel, .aa-DetachedOverlay');
        
//         if (!isInsideDialog && !isInsideAlgoliaDropdown) {
//           this.closeModal();
//         }
//       }
//     };
    
//     document.addEventListener('click', this.triggerClickHandler);
//   }

//   openModal() {
//     if (this.isOpen) return;

//     // Do not open custom dialog on mobile, as Algolia's detached view is used instead
//     if (window.innerWidth < 768) {
//       return;
//     }

//     // Handle announcement section scroll
//     const announcementSectionHeight = this.announcementSection?.offsetHeight || 0;
//     const scrollTop = document.scrollingElement.scrollTop || 0;

//     if (scrollTop < announcementSectionHeight) {
//       window.scrollTo({
//         top: announcementSectionHeight,
//         behavior: 'smooth'
//       });
//     }
    
//     document.body.classList.add('overflow-hidden');
//     document.body.classList.add('SearchModalActive');
//     this.dialog.showModal();
//     this.isOpen = true;
    
//     // Add active state to current trigger
//     if (this.activeTrigger) {
//       this.activeTrigger.classList.add('is-active');
//     }
    
//     // Focus the Algolia search input if it exists
//     setTimeout(() => {
//       const algoliaInput = this.querySelector('.aa-Input');
//       if (algoliaInput) {
//         algoliaInput.focus();
//       }
//     }, 100);
//   }

//   closeModal() {
//     if (!this.isOpen) return;
    
//     this.dialog.classList.add('animate-close');
//     this.isOpen = false;

//     // Remove active state from all triggers
//     const triggers = document.querySelectorAll(`[data-search-popup="${this.popupId}"]`);
//     triggers.forEach(trigger => {
//       trigger.classList.remove('is-active');
//     });
    
//     this.activeTrigger = null;

//     setTimeout(() => {
//       document.body.classList.remove('overflow-hidden');
//       document.body.classList.remove('SearchModalActive');
//       this.dialog.close();
//       this.dialog.classList.remove('animate-close');
      
//       // Clear Algolia search if needed
//       const algoliaInput = this.querySelector('.aa-Input');
//       if (algoliaInput) {
//         algoliaInput.value = '';
//       }
//     }, 200);
//   }

//   connectedCallback() {
//     // Only setup if not already initialized
//     if (!this.isInitialized) {
//       this.init();
//     }
//   }

//   disconnectedCallback() {
//     // Clean up all event listeners when element is removed
//     if (this.triggerClickHandler) {
//       document.removeEventListener('click', this.triggerClickHandler);
//     }
    
//     if (this.escapeHandler) {
//       document.removeEventListener('keydown', this.escapeHandler);
//     }
    
//     this.isInitialized = false;
//   }
// }
  
// if (!customElements.get('algolia-search-dialog')) {
//   customElements.define('algolia-search-dialog', AlgoliaSearchDialog);
// }
  